<template>
  <v-dialog
    v-model="dialogVisible"
    scrollable
    max-height="80vh"
    max-width="90vw"
    :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title>
        <span class="headline pa-0 ma-0">Eventos do período</span>
        <v-spacer></v-spacer>
        <v-btn class="text-xs-right" flat icon color="black" @click="dialogVisible = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text :style="$vuetify.breakpoint.smAndDown ? 'height: 55vh' : 'height: 80vh'">
        <v-layout column>
          <v-flex md12 style="overflow: auto">
            <template>
              <v-timeline>
                <v-timeline-item v-for="(event, i) in events" :key="i" :color="event.color" small>
                  <template v-slot:opposite>
                    <span :class="`headline font-weight-bold ${event.color}--text`">
                      {{ moment(event.event_time).format("dddd, ll") }}
                    </span>
                  </template>
                  <div class="py-4">
                    <h2
                      :class="`headline font-weight-light mb-4 ${event.color}--text`"
                      style="background-color: #ffffff">
                      {{ event.title }}
                    </h2>
                    <div>
                      {{ event.description }}
                    </div>
                  </div>
                </v-timeline-item>
              </v-timeline>
            </template>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";

export default {
  name: "DialogEventos",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    events: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      moment,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
